import { useRef, memo } from 'react'
import { CSS } from '@dnd-kit/utilities'
import { useDraggable } from '@dnd-kit/core'

import * as Styled from './styled'

interface IProps {
  data: {
    id: string
    width: number
    left: number
    content: React.ReactNode
    disabled?: boolean
    isDraggingDisabled?: boolean
  }
}

const DndItem = ({ data }: IProps) => {
  const { id, left, width, content, disabled, isDraggingDisabled } = data
  const ref = useRef<HTMLDivElement>(null)

  const { attributes, listeners, setNodeRef, transform, isDragging } =
    useDraggable({
      id,
      data,
      disabled: disabled || isDraggingDisabled
    })

  // Combine all ref
  const combinedRef = (node: HTMLDivElement | null) => {
    setNodeRef(node)
    if (ref) ref.current = node
  }

  const style = {
    transform: CSS.Translate.toString(transform),
    left: `${left}px`,
    width: `${width}px`,
    cursor: disabled ? 'default' : 'grab'
  }

  return (
    <Styled.Item
      ref={combinedRef}
      style={style}
      $isDragging={isDragging}
      $disabled={disabled}
      {...(disabled ? {} : listeners)}
      {...attributes}
      data-id={id}
    >
      {content}
    </Styled.Item>
  )
}

export default memo(DndItem)
